import React, { useState, useEffect, useContext } from "react";
import { API_URL } from "../../components/api";
import { formatDateTime } from "../../../utils/dateFormat";
import {
    DataGrid,
    GridToolbarContainer,
    GridToolbarColumnsButton,
    GridFooterContainer,
    GridPagination,
    GridToolbarExport,
} from "@mui/x-data-grid";
import Typography from "@mui/material/Typography";
import ExcelSVG from "./ExcelSVG.svg";
import FilterSVG from "./FilterSVG.svg";
import * as XLSX from "xlsx";
import Checkbox from "@mui/material/Checkbox";
import CustomizedActions from "./BulkActions";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import AuthContext from "../../context/AuthContext";
import axios from "axios";

import Notes from "./notes";
import ReceiptTable from "./ReceiptsTable";
import Notification from "./SendNotification";
import Cards from "./labels";
import Statement from "./statement";
import "./report.css";
import { sortByPaymentDate } from "./paymentDateSort";

function DEIRKOUSHEH() {
    const { user } = useContext(AuthContext);

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchQuery, setSearchQuery] = useState("");
    const [Client, setClient] = useState("");
    const [Fullname, setFullname] = useState("");

    const [Cl, setCl] = useState("");
    const [checkedRows, setCheckedRows] = useState([]);
    const [show, setShow] = useState(false);
    const [showNotification, setShowNotification] = useState(false);
    const [showReceipt, setShowReceipt] = useState(false);

    const [showCollectedModal, setShowCollectedModal] = useState(false);
    const [showPostponeModal, setShowPostponeModal] = useState(false);
    const [selectedSubscriptionId, setSelectedSubscriptionId] = useState(null);

    const [showStatement, setShowStatement] = useState(false);
    const [showFilterModal, setShowFilterModal] = useState(false);
    const [gridFilterModel, setGridFilterModel] = useState({ items: [] });
    const [searchInput, setSearchInput] = useState("");
    const [columnVisibilityModel, setColumnVisibilityModel] = useState({});
    const [searchFilterTimeout, setSearchFilterTimeout] = useState(null);
    const [pageSize, setPageSize] = useState(100);
    const [currentPage, setCurrentPage] = useState(0);

    // Modal Handlers
    const CloseCollect = () => setShow(false);
    const ShowCollect = () => setShow(true);
    const CloseNotification = () => setShowNotification(false);
    const ShowNotification = () => setShowNotification(true);
    const CloseReceipt = () => setShowReceipt(false);
    const ShowReceipt = () => setShowReceipt(true);
    const ClosePostponeModal = () => setShowPostponeModal(false);
    const ShowPostponeModal = (sub_id) => { setSelectedSubscriptionId(sub_id); setShowPostponeModal(true); };
    const CloseCollectedModal = () => setShowCollectedModal(false);
    const ShowCollectedModal = (sub_id) => { setSelectedSubscriptionId(sub_id); setShowCollectedModal(true); };
    const CloseStatement = () => setShowStatement(false);
    const ShowStatement = () => setShowStatement(true);

    const [filters, setFilters] = useState({
        status: "",
        fullname_en: "",
        suffix: "",
        balance_usd: "",
        balance: "",
        client_notes: "",
        payment_date: "",
        due: "",
        expiration_date: "",
        collector: "",
        label: "",
        labels: "",
        note_details: "",
    });

    const handlePostponeConfirm = async () => {
        try {
            const authTokens = JSON.parse(localStorage.getItem("authTokens"));
            await axios.post(`${API_URL}/accounting/info/Postpone/`,
                { action: "postpone", sub_id: selectedSubscriptionId, username: user.username },
                { headers: { Authorization: `Bearer ${authTokens.access}` } }
            );
            fetchData();
            setShowPostponeModal(false);
        } catch (error) { console.error(error); }
    };

    const handleCollectedConfirm = async () => {
        try {
            const authTokens = JSON.parse(localStorage.getItem("authTokens"));
            await axios.post(`${API_URL}/accounting/info/Collected/`,
                { action: "toBeCollected", sub_id: selectedSubscriptionId, username: user.username },
                { headers: { Authorization: `Bearer ${authTokens.access}` } }
            );
            fetchData();
            setShowCollectedModal(false);
        } catch (error) { console.error(error); }
    };

    const fetchData = async () => {
        try {
            setLoading(true);
            const authTokens = JSON.parse(localStorage.getItem("authTokens"));
            const response = await axios.get(`${API_URL}/accounting/info/DEIRKOUSHEH/`, {
                headers: { Authorization: `Bearer ${authTokens.access}` },
                params: {
                    username: user.username,
                    dealer_ids: "41"
                },
            });

            if (response.status === 200) {
                const validatedData = sortByPaymentDate(Array.isArray(response.data)
                    ? response.data
                    : (response.data.results || []));
                setData(validatedData);
            }
        } catch (error) {
            console.error("Fetch Error:", error);
            setData([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { fetchData(); }, [user.username]);

    const getStatusCellStyle = (params) => {
        const styles = {
            offline: "status-offline", online: "status-online",
            inactive: "status-inactive", expired: "status-expired",
            hold: "status-hold", HSI: "status-hsi"
        };
        return styles[params.value] || "";
    };

    const columns = [
        {
            field: "checkbox",
            headerName: "",
            width: 100,
            renderHeader: () => (
                <Checkbox
                    indeterminate={checkedRows.length > 0 && checkedRows.length < filteredRows.length}
                    checked={checkedRows.length === filteredRows.length && filteredRows.length > 0}
                    onChange={handleSelectAllCheckboxes}
                />
            ),
            renderCell: (params) => (
                <Checkbox
                    className="subcheck"
                    checked={checkedRows.includes(params.row.subscription_id)}
                    onChange={(event) => handleCheckboxChange(event, params.row.subscription_id)}
                />
            ),
        },
        { field: "status", headerName: "Status", flex: 2, minWidth: 100, cellClassName: (params) => getStatusCellStyle(params) },
        { field: "fullname_en", headerName: "Full Name", flex: 2, minWidth: 250 },
        { field: "suffix", headerName: "Suffix", flex: 2, minWidth: 100 },
        { field: "balance_usd", headerName: "Balance (USD)", flex: 1, minWidth: 150 },
        { field: "balance", headerName: "Initial Balance", flex: 1, minWidth: 150 },
        { field: "client_notes", headerName: "Client Notes", flex: 1, minWidth: 150 },
        {
            field: "payment_date",
            headerName: "Payment Date",
            flex: 1,
            minWidth: 200,
            valueFormatter: (params) => {
                const date = new Date(params.value);
                return isNaN(date.getTime()) ? params.value : formatDateTime(date);
            },
        },
        { field: "due", headerName: "Due", flex: 1, minWidth: 150 },
        {
            field: "expiration_date",
            headerName: "Expiration Date",
            flex: 1,
            minWidth: 200,
            valueFormatter: (params) => {
                const date = new Date(params.value);
                return isNaN(date.getTime()) ? params.value : formatDateTime(date);
            },
        },
        { field: "collector", headerName: "Collector", flex: 2, minWidth: 150 },
        { field: "label", headerName: "MC Category", flex: 2, minWidth: 100 },
        { field: "labels", headerName: "Labels", flex: 1, minWidth: 120, renderCell: (params) => <Cards sub_id={params.row.subscription_id} /> },
        {
            field: "note_details",
            headerName: "Latest Note",
            flex: 2,
            minWidth: 250,
            valueGetter: (params) => params.row.note_user && params.row.latest_note ? `${params.row.note_user}: ${params.row.latest_note}` : "No Note",
        },
        {
            field: "actions",
            headerName: "Actions",
            minWidth: 700,
            flex: 2,
            renderCell: (params) => (
                <div>
                    <button className="edit-client" onClick={() => { setClient(params.row.subscription_id); setFullname(params.row.fullname_en); ShowCollect(); }}>Notes</button>
                    <button className="edit-client" onClick={() => { setCl(params.row.client_id); ShowReceipt(); }}>Receipt</button>
                    <button className="edit-client" onClick={() => { setClient(params.row.subscription_id); setFullname(params.row.fullname_en); ShowNotification(); }}>Notifications</button>
                    <button className="edit-client postpone-btn" onClick={() => ShowPostponeModal(params.row.subscription_id)}>Postpone</button>
                    <button className="edit-client postpone-btn" onClick={() => ShowCollectedModal(params.row.subscription_id)}>To Be Collected</button>
                    <button className="edit-client" onClick={() => { ShowStatement(); setCl(params.row.client_id); }}>Statement</button>
                </div>
            ),
        },
    ];

    const handleCheckboxChange = (event, subscriptionId) => {
        const checked = event.target.checked;
        setCheckedRows(prev => checked ? [...prev, subscriptionId] : prev.filter(id => id !== subscriptionId));
    };

    const handleSelectAllCheckboxes = () => {
        const visibleIds = filteredRows.slice(currentPage * pageSize, (currentPage + 1) * pageSize).map(r => r.subscription_id);
        const allSelected = visibleIds.every(id => checkedRows.includes(id));
        setCheckedRows(prev => allSelected ? prev.filter(id => !visibleIds.includes(id)) : [...new Set([...prev, ...visibleIds])]);
    };

    const handleSearchChange = (event) => {
        const query = event.target.value;
        setSearchInput(query);
        if (searchFilterTimeout) clearTimeout(searchFilterTimeout);
        setSearchFilterTimeout(setTimeout(() => setSearchQuery(query), 100));
    };

    /**
     * FILTER LOGIC:
     */
    const filteredRows = Array.isArray(data) ? data.filter((row) => {

        if (Number(row.balance_usd) <= 0) return false;
        if (Number(row.balance) === 0) return false;

        const searchMatch = searchQuery.split(" ").every(word =>
            Object.values(row).some(value => String(value).toLowerCase().includes(word.toLowerCase().trim()))
        );

        const modalFilterMatch = Object.keys(filters).every(key =>
            !filters[key] ||
            String(row[key] || "").toLowerCase().includes(String(filters[key]).toLowerCase())
        );

        return searchMatch && modalFilterMatch;
    }) : [];

    const columnHeaders = {
        status: "Status", fullname_en: "Full Name", suffix: "Suffix", balance_usd: "Balance (USD)",
        balance: "Initial Balance", client_notes: "Client Notes", payment_date: "Payment Date",
        due: "Due", expiration_date: "Expiration Date", collector: "Collector", label: "Label", note_details: "Latest Note",
    };

    const handleExportToExcel = () => {
        const transformedRows = filteredRows.map(row => {
            const obj = {};
            Object.keys(columnHeaders).forEach(key => { if (columnVisibilityModel[key] !== false) obj[columnHeaders[key]] = row[key] || ""; });
            return obj;
        });
        const worksheet = XLSX.utils.json_to_sheet(transformedRows);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "DEIRKOUSHEH");
        XLSX.writeFile(workbook, "DEIRKOUSHEH_Report.xlsx");
    };

    const CustomToolbar = () => (
        <GridToolbarContainer>
            <GridToolbarColumnsButton />
            <Button onClick={() => setShowFilterModal(true)} variant="outline-primary" style={{ border: "none" }}>
                <img src={FilterSVG} alt="Filter" style={{ width: "18px", marginRight: "8px" }} /> Filter
            </Button>
            <GridToolbarExport />
            <Button onClick={handleExportToExcel} variant="outline-success" style={{ border: "none" }}>
                <img src={ExcelSVG} alt="Excel" style={{ width: "20px", marginRight: "8px" }} /> Excel
            </Button>
        </GridToolbarContainer>
    );

    return (
        <div className="InternetTable">
            <div className="actions">
                <CustomizedActions subscriptions={checkedRows} deselect={() => setCheckedRows([])} fetch={fetchData} />
                <input type="text" placeholder="Search DEIRKOUSHEH..." value={searchInput} onChange={handleSearchChange} className="search-client" />
            </div>

            {!loading && (
                <div style={{ height: 600, width: "100%" }}>
                    <DataGrid
                        rows={filteredRows}
                        columns={columns}
                        getRowId={(row) => row.subscription_id}
                        filterModel={gridFilterModel}
                        onFilterModelChange={setGridFilterModel}
                        columnVisibilityModel={columnVisibilityModel}
                        onColumnVisibilityModelChange={setColumnVisibilityModel}
                        components={{
                            Footer: () => (
                                <GridFooterContainer style={{ display: "flex", justifyContent: "space-between" }}>
                                    <Typography style={{ marginLeft: "16px", color: "white" }}>Selected: {checkedRows.length} | Total DEIRKOUSHEH: {filteredRows.length}</Typography>
                                    <GridPagination />
                                </GridFooterContainer>
                            ),
                            Toolbar: CustomToolbar,
                        }}
                        pageSize={pageSize}
                        onPageSizeChange={setPageSize}
                        pagination
                        page={currentPage}
                        onPageChange={setCurrentPage}
                        disableSelectionOnClick
                    />
                </div>
            )}

            {/* Modals */}
            <Modal show={showPostponeModal} onHide={ClosePostponeModal}>
                <Modal.Header closeButton><Modal.Title>Confirm Postpone</Modal.Title></Modal.Header>
                <Modal.Body>Are you sure you want to postpone this subscription?</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={ClosePostponeModal}>No</Button>
                    <Button variant="primary" onClick={handlePostponeConfirm}>Yes</Button>
                </Modal.Footer>
            </Modal>

            <Modal show={show} onHide={CloseCollect} className="modal-lg">
                <div className="forma"><Modal.Header closeButton><Modal.Title>{Fullname} Notes</Modal.Title></Modal.Header><Notes sub_id={Client} /></div>
            </Modal>

            <Modal show={showNotification} onHide={CloseNotification} className="modal-lg">
                <div className="forma"><Modal.Header closeButton><Modal.Title>Notification for {Fullname}</Modal.Title></Modal.Header><Notification sub_id={Client} /></div>
            </Modal>

            <Modal show={showReceipt} onHide={CloseReceipt} className="modal-lg">
                <div className="forma"><Modal.Header closeButton><Modal.Title>{Fullname} Receipts</Modal.Title></Modal.Header><ReceiptTable client_id={Cl} /></div>
            </Modal>

            <Modal show={showStatement} onHide={CloseStatement} className="modal-xl">
                <Modal.Header closeButton><Modal.Title>Statement of Account</Modal.Title></Modal.Header>
                <Modal.Body><Statement client_id={Cl} /></Modal.Body>
            </Modal>

            <Modal show={showFilterModal} onHide={() => setShowFilterModal(false)}>
                <Modal.Header closeButton><Modal.Title>Filters</Modal.Title></Modal.Header>
                <Modal.Body>
                    {Object.keys(columnHeaders).map((field) => (
                        <div key={field} className="filter">
                            <label>{columnHeaders[field]}</label>
                            <input type="text" placeholder={`Filter by ${columnHeaders[field]}`} value={filters[field] || ""} onChange={(e) => setFilters(prev => ({ ...prev, [field]: e.target.value }))} className="filter-input" />
                        </div>
                    ))}
                </Modal.Body>
            </Modal>

            <Modal show={showCollectedModal} onHide={CloseCollectedModal}>
                <Modal.Header closeButton><Modal.Title>To be Collected</Modal.Title></Modal.Header>
                <Modal.Body>Are you sure you want to collect this subscription?</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={CloseCollectedModal}>No</Button>
                    <Button variant="primary" onClick={handleCollectedConfirm}>Yes</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default DEIRKOUSHEH;